<template>
  <div style="display: flex; flex-direction: column">
    <div class="red" style="display: flex; flex-direction: column">
      <el-input :value="cargoDoc.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
      <span>{{ job.jointMasterHBLUuid ? $t("SeaExport.TicketHasMerged") : job.typeHBL === BillType.SPLIT_BILL_TYPE.code ? $t("SeaExport.TicketHasSplit") : "" }}</span>
    </div>
    <div>
      <el-checkbox :value="cargoDoc.releaseReview === 1" :disabled="true" style="margin-right: 6px">{{ $t("SeaExport.DataSent") }}</el-checkbox>
      <el-checkbox :value="cargoDoc.payable" :disabled="true" style="margin-right: 6px">{{ $t("SeaExport.Completed") }}</el-checkbox>
      <el-checkbox :value="cargoDoc.withhold" :disabled="true" style="margin-right: 0px">{{ $t("SeaExport.CargoDetention") }}</el-checkbox>
    </div>
  </div>
</template>

<script>
import * as BillType from '@/class/cargo/model/parameters/BillType'

export default {
  name: 'SeHblRequestReleaseState',
  props: {
    job: { type: Object, default: () => { return {} } },
    cargoDoc: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      BillType
    }
  }
}
</script>
